import styled from 'styled-components';

export const AlarmsCellWrapper = styled.div`
    display: flex;
    gap: 8px;
`;

export const AlarmBlankSpace = styled.div`
    width: 35px;
`;

export const AlarmTooltipTitle = styled.div.attrs({ slot: 'title' })`
    font-size: 14px;
    font-weight: 400;
`;

export const AlarmTooltipBody = styled.span`
    font-size: 12px;
    font-weight: 400;
`;
